// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NextImage$PorterinFeature from "../../../../../../ui/components/NextImage.mjs";
import * as HomeStoreEn$PorterinFeature from "../../../../../home/domain/store/HomeStoreEn.mjs";
import * as PaymentSuccessStore$PorterinFeature from "../store/PaymentSuccessStore.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../../../shared/core/helpers/PublishEventsHelper.mjs";
import * as PaymentSuccessModuleScss from "../styles/PaymentSuccess.module.scss";
import * as CategoryAnalyticsStore$PorterinFeature from "../../../../../fare-estimate-v1/domain/store/CategoryAnalyticsStore.mjs";
import * as PaymentSuccessMobFooterCmp$PorterinFeature from "./PaymentSuccessMobFooterCmp.mjs";

var styles = PaymentSuccessModuleScss;

function PaymentSuccessCmp(Props) {
  React.useEffect((function () {
          PublishEventsHelper$PorterinFeature.publishEvents(CategoryAnalyticsStore$PorterinFeature.pnm, HomeStoreEn$PorterinFeature.paymentSuccessEvent, undefined);
        }), []);
  return React.createElement("div", {
              className: styles["payment-success-container"]
            }, React.createElement("div", {
                  className: styles["payment-success-main"]
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: PaymentSuccessStore$PorterinFeature.successImgUrl,
                      height: 80.0,
                      width: 80.0,
                      alt: PaymentSuccessStore$PorterinFeature.paymentSuccessIconAlt
                    }), React.createElement("h3", {
                      className: styles["payment-success-heading"]
                    }, PaymentSuccessStore$PorterinFeature.paymentSuccessHeader)), React.createElement("div", {
                  className: styles["heading-container"]
                }, React.createElement("h3", {
                      className: styles.heading
                    }, PaymentSuccessStore$PorterinFeature.weAreBetterOnApp)), React.createElement("div", {
                  className: styles["app-image"]
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: PaymentSuccessStore$PorterinFeature.orderDetailsImgUrl,
                      height: 319.0,
                      width: 300.0,
                      alt: PaymentSuccessStore$PorterinFeature.orderDetailsIconAlt
                    })), React.createElement(PaymentSuccessMobFooterCmp$PorterinFeature.make, {}));
}

var make = PaymentSuccessCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
